import PropTypes from 'prop-types';
import { Center, Spinner, Text } from '@chakra-ui/react';

function LoadingSpinner({ speed, color, thickness, size, message }) {
  return (
    <Center height="100%" flexDirection="column" gap={4}>
      <Spinner speed={speed} color={color} thickness={thickness} size={size} />
      <Text>{message}</Text>
    </Center>
  );
}

LoadingSpinner.defaultProps = {
  speed: '1s',
  color: 'red.500',
  thickness: '4px',
  size: 'md',
  message: 'Loading...',
};

LoadingSpinner.propTypes = {
  speed: PropTypes.string,
  color: PropTypes.string,
  thickness: PropTypes.string,
  size: PropTypes.string,
  message: PropTypes.string,
};

export default LoadingSpinner;
